/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $CreateApprovalCompetencyRequest = {
  properties: {
    min: {
      type: 'number',
    },
    max: {
      type: 'number',
    },
    name: {
      type: 'string',
      isRequired: true,
    },
  },
} as const;
